const REVIEWS = [
    {
        user: {
            name: 'Benjamin Mitchell',
            role: 'Student',
            image: ''
        },
        text: "As a student pursuing higher education, receiving the grant from to World Support Foundation was a tremendous help. It provided me with the financial assistance I needed to cover my tuition fees and other educational expenses. With the burden of financial stress lifted off my shoulders, I was able to focus wholeheartedly on my studies and perform exceptionally well. The grant has opened doors of opportunity for me, and I am grateful to World Support Foundation for investing in my future."
    } ,
    {
        user: {
            name: 'Olivia Watson',
            role: 'Office Assistant',
            image: ''
        },
        text: "Being a nonprofit organization, we heavily rely on grants to carry out our community programs. When we received the grant from World Support Foundation, it was a turning point for us. The funding allowed us to expand our outreach initiatives, provide essential services to those in need, and create a lasting impact on the community. Thanks to the grant, we were able to improve countless lives and bring about positive change. We are immensely thankful to World Support Foundation for their belief in our mission."
    },
    {
        user: {
            name: 'Ethan Reynolds',
            role: 'Teacher',
            image: ''
        },
        text: "I am incredibly grateful for the grant I received from World Support Foundation. It has been a game-changer for my small business. With the funds, I was able to purchase new equipment and expand my production capacity. This has not only increased our efficiency but also allowed us to take on more clients and generate higher revenue. The grant has truly been a catalyst for growth, and I can't thank World Support Foundation enough for their support."
    }
];

const US_STATES = [
    "Alaska",
    "Alabama",
    "Arkansas",
    "American Samoa",
    "Arizona",
    "California",
    "Colorado",
    "Connecticut",
    "District of Columbia",
    "Delaware",
    "Florida",
    "Georgia",
    "Guam",
    "Hawaii",
    "Iowa",
    "Idaho",
    "Illinois",
    "Indiana",
    "Kansas",
    "Kentucky",
    "Louisiana",
    "Massachusetts",
    "Maryland",
    "Maine",
    "Michigan",
    "Minnesota",
    "Missouri",
    "Mississippi",
    "Montana",
    "North Carolina",
    " North Dakota",
    "Nebraska",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "Nevada",
    "New York",
    "Ohio",
    "Oklahoma",
    "Oregon",
    "Pennsylvania",
    "Puerto Rico",
    "Rhode Island",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Virginia",
    "Virgin Islands",
    "Vermont",
    "Washington",
    "Wisconsin",
    "West Virginia",
    "Wyoming"];
const GRANT_CATEGORIES = [
    "Arts",
    "Business and Commerce",
    "Community Development",
    "Disaster Prevention and Relief",
    "Education",
    "Employment, Labour and Training",
    "Energy",
    "Environmental Quality",
    "Food and Nutrition",
    "Health",
    "Housing",
    "Humanities",
    "Information and Statistics",
    "Law, Justice and Legal Services",
    "Natural Resources",
    "Recovery Act",
    "Regional Development",
    "Science and Technology",
    "Social Services and Income Security",
    "Transportation",
];

export const WSF_DATA = {REVIEWS, US_STATES, GRANT_CATEGORIES};

